import DOMPurify from 'dompurify'

const allowedHref = /^(?:(?:https?|mailto|tel):|\/|#)/i

DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.nodeName !== 'A') return
  const el = node as Element

  const href = (el.getAttribute('href') || '').trim()
  if (!href || !allowedHref.test(href)) {
    el.removeAttribute('href')
  }

  const target = el.getAttribute('target')
  if (target) {
    if (target === '_blank') {
      el.setAttribute('rel', 'noopener noreferrer')
    } else {
      el.removeAttribute('target')
      el.removeAttribute('rel')
    }
  } else {
    el.removeAttribute('rel')
  }
})

export function useSanitizeHtml() {
  const sanitizeHtml = (html: unknown): string =>
    DOMPurify.sanitize(String(html ?? ''), {
      USE_PROFILES: { html: true },
      ADD_ATTR: ['target', 'rel'],
    })

  return { sanitizeHtml }
}
